import {
    PrintoutTableCellNode,
    PrintoutTableHeaderNode,
    PrintoutTableNode,
    PrintoutTableRowNode,
} from "./printoutTableNodes";

export const printoutTableExtensions = [
    PrintoutTableNode,
    PrintoutTableRowNode,
    PrintoutTableHeaderNode,
    PrintoutTableCellNode,
];
